module.exports = __webpack_public_path__ + "static/media/desktop_GMA-S2100_Desktop_03.fd6e3d2a.jpg";